import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Search() {
    const { t } = useTranslation();
    const nav = useNavigate();
    const [keyword, setKeyword] = useState("");

    const handleSearch = (e) => {
        e.preventDefault();
        if (keyword.trim()) {
            nav(`/products?search=${keyword}`);
        }
    };

    return (
        <form onSubmit={handleSearch} className="w-100">
            <div className="input-group shadow-sm rounded overflow-hidden border">
                <input
                    type="text"
                    className="form-control border-0 px-3 shadow-none"
                    placeholder={t("search_placeholder")}
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                />
                <button
                    type="submit"
                    className="btn btn-primary px-4 d-flex align-items-center justify-content-center border-0"
                >
                    <i className="bi bi-search fs-5"></i>
                </button>
            </div>
        </form>
    );
}